import { render } from "./Customization.vue?vue&type=template&id=e4e4b012&scoped=true&ts=true"
import script from "./Customization.vue?vue&type=script&lang=ts"
export * from "./Customization.vue?vue&type=script&lang=ts"

import "./Customization.vue?vue&type=style&index=0&id=e4e4b012&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e4b012"]])

export default __exports__